define('plugin/product/model/ProductModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    return BaseModel.extend({

        defaults: {
            id: null,
            name: '',
            description: '',
            price: 0,
            currency: '',
            default_qty: 0,
            qty: null
        },

        parse: function (data) {
            var res = BaseModel.prototype.parse.apply(this, [data]);

            data.qty = data.default_qty;

            return data;
        }

    });

});
